import React from 'react';

import { BaseLinePropsType } from './types';

import './BaseLine.scss';

const Baseline = ({ isToday, top }: BaseLinePropsType) => {
  
  return (
    <div className={'baseline'} style={{ top: `${top}px`, opacity: `${isToday ? 1 : 0.6}` }}>
      {isToday && <div className={'baseline-circle'} />}
    </div>
  );
};

export default Baseline;
